import React, { useMemo, memo } from "react";
import { useTranslation } from "react-i18next";
import { convertSlaTime } from "../../../Libs/CustomMethods/customMethods";

import "./style.scss";

function SlaStatus({ data }) {
  const { t } = useTranslation();

  const sla = useMemo(() => {
    const { time } = data;

    if (!time || time < 0) {
      return null
    }

    return convertSlaTime(time);
  }, [data]);

  return (
    <div className="sla-status" type={data.type} title={sla}>
      <span className="status">{t(data.type)}</span>
      <span className="sla">{sla}</span>
    </div>
  );
}

export default memo(SlaStatus);
